import {Fragment, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {UpdateOrderComponent} from "../../component/UpdateOrderComponent";
import {BreadCrumb} from "../../component/Breadcrumb";
import {get, post} from "../../js/api";
import {OrderCorrespondence, prepareOrderCorrespondenceMessage} from "../../component/OrderCorrespondence";
import {Button} from "../../component/form/Button";
import {useTanPrefill} from "../../js/useTanPrefill";
import {markDirty, showError, showMessage} from "../../js/main";
import {RefreshSignal} from "../../js/util";


const refresh = new RefreshSignal();

export const UpdateOrder = ({}) => {

    const {orderId} = useParams();
    const initialTan = useTanPrefill();

    const [reply, setReply] = useState();
    const [isSubmitting, setSubmitting] = useState(false);

    const correspondenceForm = useRef();


    const sendMessage = async () => {
        if(!correspondenceForm.current.checkValidity()){
            return;
        }

        setSubmitting(true)
        try {
            const message = await prepareOrderCorrespondenceMessage(reply, false);
            await post(`/orders/${orderId}/correspondence`, message);
            markDirty();
            showMessage("Die Nachricht wurde gesendet.")
            refresh.changed();
        } catch (e) {
            showError("Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <Fragment>
            <UpdateOrderComponent identifier={orderId} token={false} initialTan={initialTan}></UpdateOrderComponent>
            <form ref={correspondenceForm} onSubmit={(e) => {
                e.preventDefault();
                sendMessage();
            }}>
                <OrderCorrespondence isPublic={false} identifier={orderId} onCreateReply={setReply}
                                     adminView={false} refresh={refresh}/>
                {reply && <div className={"safe-actions mt-1"}>
                    <Button key="submit" theme="blue mb-1"
                            width={230}
                            submitting={isSubmitting}>Antwort
                        senden</Button>
                </div>}
            </form>
        </Fragment>
    );

};
